import api from '../lib/api';

export const RUN_SCHEDULES_LOADING = 'RUN_SCHEDULES_LOADING';
export const FETCH_RUN_SCHEDULES = 'FETCH_RUN_SCHEDULES';
export const CREATE_RUN_SCHEDULE = 'CREATE_RUN_SCHEDULE';
export const UPDATE_RUN_SCHEDULE = 'UPDATE_RUN_SCHEDULE';
export const DELETE_RUN_SCHEDULE = 'DELETE_RUN_SCHEDULE';

function fetchRunSchedules(query) {
  return (dispatch) => {
    dispatch({ type: RUN_SCHEDULES_LOADING, payload: true });
    return api.getRunSchedules(query)
      .then((data) => {
        dispatch({ type: FETCH_RUN_SCHEDULES, payload: data.data });
        return data;
      })
      .then((data) => {
        dispatch({ type: RUN_SCHEDULES_LOADING, payload: false });
        return data;
      });
  };
}

function createRunSchedule(args) {
  return (dispatch) => api
    .createRunSchedule(args).then((data) => {
      dispatch({ type: CREATE_RUN_SCHEDULE, payload: data });
      return data;
    });
}

function updateRunSchedule(id, updateObj) {
  return (dispatch) => api
    .updateRunSchedule(id, updateObj).then((data) => {
      dispatch({ type: UPDATE_RUN_SCHEDULE, payload: data });
      return data;
    });
}

function deleteRunSchedule(id) {
  return (dispatch) => api
    .deleteRunSchedule(id).then((data) => {
      dispatch({ type: DELETE_RUN_SCHEDULE, payload: data });
      return data;
    });
}

export default {
  fetchRunSchedules,
  createRunSchedule,
  updateRunSchedule,
  deleteRunSchedule,
};
